import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import usePrevious from 'hooks/usePrevious'
import { getIsFreePreviewLuxPlusMember } from 'luxPlus/selectors/featureToggle'
import { useContext, useEffect } from 'react'
import LuxPlusMonthFreePreviewInfoModal from './LuxPlusMonthFreePreviewInfoModal'
import LuxPlusMonthLandingPageBenefitsHero from './LuxPlusMonthLandingPageBenefitsHero'
import LuxPlusMonthLandingPageCarousels from './LuxPlusMonthLandingPageCarousels'
import LuxPlusMonthLandingPageFaq from './LuxPlusMonthLandingPageFaq'
import LuxPlusMonthLandingPageHero from './LuxPlusMonthLandingPageHero'
import LuxPlusMonthLandingPageOfferMessageBanner from './LuxPlusMonthLandingPageOfferMessageBanner'

function LuxPlusMonthLandingPageContent() {
  const showModal = useContext(ModalContext)
  const isFreePreviewMember = useAppSelector(getIsFreePreviewLuxPlusMember)
  const subscriptionItem = useAppSelector(state => state.auth.account.luxPlus.member.subscription.item)
  const previousSubscriptionItemTier = usePrevious(subscriptionItem?.tier)
  const hasSeenLuxPlusMonthFreePreviewModal = useAppSelector(state => state.luxPlus.hasSeenLuxPlusMonthFreePreviewModal)

  const hasManuallyEnrolledInFreePreview =
    !hasSeenLuxPlusMonthFreePreviewModal &&
    isFreePreviewMember && // is now a free-preview member
    previousSubscriptionItemTier !== 'free_preview' && // wasn't previously free-preview
    subscriptionItem?.trigger === 'manual-free-preview-enroll' // manually triggered the free-preview

  useEffect(() => {
    if (hasManuallyEnrolledInFreePreview) {
      showModal(<LuxPlusMonthFreePreviewInfoModal />)
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [hasManuallyEnrolledInFreePreview])

  return <div>
    <LuxPlusMonthLandingPageHero />
    <LuxPlusMonthLandingPageOfferMessageBanner />
    <LuxPlusMonthLandingPageCarousels />
    <LuxPlusMonthLandingPageBenefitsHero />
    <LuxPlusMonthLandingPageFaq />
  </div>
}

export default LuxPlusMonthLandingPageContent
